import { render, staticRenderFns } from "./SessionsList.vue?vue&type=template&id=2c76c622&scoped=true"
import script from "./SessionsList.vue?vue&type=script&lang=js"
export * from "./SessionsList.vue?vue&type=script&lang=js"
import style0 from "./SessionsList.vue?vue&type=style&index=0&id=2c76c622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c76c622",
  null
  
)

export default component.exports